import styled, { css } from 'styled-components';

const GAP = 12;

export const SliderContainer = styled.div<{ $isMobileGrid?: boolean }>`
  ${({ $isMobileGrid }) =>
    $isMobileGrid &&
    css`
      @media screen and (max-width: 599px) {
        display: none;
      }
    `};
`;

export const GridContainer = styled.div`
  display: block;

  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const Grid = styled.ul`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  list-style: none;
  margin: 24px 0;
  padding-inline-start: 0;
`;

export const GridHeading = styled.h2`
  color: var(--dcm-section-title-color);
  font-size: 20px;
  font-weight: bold;
  line-height: ${24 / 20};

  @media screen and (min-width: 600px) {
    font-size: 26px;
  } ;
`;

export const Item = styled.li<{ $isMobileGrid?: boolean; $isHidden?: boolean }>`
  display: block;
  ${({ $isMobileGrid, $isHidden }) =>
    $isMobileGrid &&
    css`
      @media screen and (max-width: 599px) {
        display: ${$isHidden ? 'none' : 'block'};
        width: calc(${(1 / 3) * 100}% - ${(GAP * 2) / 3}px);
      }

      @media screen and (max-width: 430px) {
        width: calc(50% - ${GAP / 2}px);
      }
    `};
`;

export const ViewAllButton = styled.button`
  appearance: none;
  background: var(--dcm-categories-view-all-bg);
  border: none;
  border-radius: ${({ theme }) => theme.customized.radius.buttons};
  color: var(--dcm-categories-view-all-color);
  cursor: pointer;
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: ${24 / 16};
  margin: 0 0 32px;
  padding: 16px;
  text-transform: var(--dct--customized-textTransforms-buttons);
  width: 100%;

  @media screen and (min-width: 600px) {
    display: none;
  }
`;
